import { render, staticRenderFns } from "./roleList.vue?vue&type=template&id=1fe5b141&scoped=true"
import script from "./roleList.vue?vue&type=script&lang=ts"
export * from "./roleList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe5b141",
  null
  
)

export default component.exports